<template>
  <div>
    <span class="title-bar title-h4">트랜잭션 정보</span>
    <el-row type="flex" class="list form-list" :gutter="20">
      <el-col :span="12">
        <el-form :model="txInfo" label-width="180px" label-position="left">
          <el-form-item label="인스턴스 명">{{ getValueAfterCheckEmpty(txInfo.objName) }}</el-form-item>
          <el-form-item label="경로">{{ getValueAfterCheckEmpty(txInfo.contextRootPath) }}</el-form-item>
          <el-form-item label="서비스">{{ getValueAfterCheckEmpty(txInfo.service) }}</el-form-item>
          <el-form-item label="응답 코드">{{ getValueAfterCheckEmpty(txInfo.statusCode) }}</el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <el-form :model="txInfo" label-width="180px" label-position="left">
          <el-form-item label="IP 주소">{{ getValueAfterCheckEmpty(txInfo.ipaddress) }}</el-form-item>
          <el-form-item label="유저 에이전트">{{ getValueAfterCheckEmpty(txInfo.userAgent) }}</el-form-item>
          <el-form-item label="시작시각">{{ converDateToString(txInfo.startTime) }}</el-form-item>
          <el-form-item label="종료시각">{{ converDateToString(txInfo.endTime) }}</el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { isEmpty } from '@/utils/basic';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertMillisecondsToSeconds } from '@/utils/number';
import { getDateToString } from '@/utils/date';

export default {
  name: 'WTransactionInfoView',
  props: {
    txInfo: Object,
  },
  methods: {
    getValueAfterCheckEmpty,
    /**
     * 에러 수 천단위 환산
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     * @author jda
     */
    convertTimeFormat(value) {
      if (isEmpty(value)) {
        return EMPTY_TEXT;
      }
      return convertMillisecondsToSeconds(value);
    },
    /**
   * Date -> String 변환
   * @param  {[type]} value [description]
   * @return {[type]}       [description]
   * @author jda
   */
    converDateToString(value) {
      if (isEmpty(value)) {
        return EMPTY_TEXT;
      }
      return getDateToString(value, 'YYYY-MM-DD HH:mm:ss.SSS');
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/apm/transaction-matrix/components/TransactionInfoView.vue